import moment from 'moment'
import { useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import CurrencyAmountInput from '../../../../../components/forms/CurrencyAmountInput'
import InputPrefix from '../../../../../components/forms/InputPrefix'
import Select from '../../../../../components/forms/Select'
import TextArea from '../../../../../components/forms/TextArea'
import Button from '../../../../../components/misc/Button'
import { SelectInterface } from '../../../../../interfaces/InterfacesLocal'
import { useAppSelector } from '../../../../../store/hooks'
import { translatePaymetMethods } from '../../../../../utils/translate'

// Interface for the currency amount input value
interface CurrencyAmountValue {
  amount: number
  codeCurrency: string
}

// Interface for the registered payment data passed to action
interface RegisteredPayment {
  amount: number
  codeCurrency: string
  paymentWay: string
  operationNumber?: string
  observations?: string
}

interface Props {
  close: () => void
  action: (_registeredPayments: RegisteredPayment) => void
  defaultPaymentMethod?: string
  defaultPaymentCurrency?: string
}

export const AddPay = ({
  close,
  action,
  defaultPaymentMethod,
  defaultPaymentCurrency,
}: Props) => {
  // Hooks
  const { handleSubmit, control, watch, trigger, clearErrors } =
    useForm<Record<string, unknown>>()

  const { business } = useAppSelector((state) => state.init)

  const currenciesSelector: string[] = []
  business?.availableCurrencies.forEach((itm) => {
    currenciesSelector.push(itm.code)
  })

  const paymentMethods: SelectInterface[] =
    business?.configurationsKey
      .find((itm) => itm.key === 'payment_methods_enabled')
      ?.value.split(',')
      .map((elem) => ({ id: elem, name: translatePaymetMethods(elem) })) ?? []

  const onSubmitPay: SubmitHandler<Record<string, unknown>> = async () => {
    if (!(await trigger())) return
    const registeredPaymentsFrom = watch(
      'registeredPayments'
    ) as CurrencyAmountValue
    const paymentWay = watch('paymentWay') as string
    const operationNumber = watch('operationNumber') as string | undefined
    const observations = watch('observations') as string | undefined
    //data.registeredPayments.paymentWay = data?.paymentWay

    const registeredPayments: RegisteredPayment = {
      amount: registeredPaymentsFrom.amount,
      codeCurrency: registeredPaymentsFrom.codeCurrency,
      paymentWay,
      operationNumber,
      observations,
    }
    action(registeredPayments)
    close()
  }

  useEffect(() => {
    clearErrors()
  }, [clearErrors])

  const paymentWay = watch('paymentWay') ?? paymentMethods[0].id
  return (
    <>
      <form className="px-8" id="payFrom" onSubmit={handleSubmit(onSubmitPay)}>
        <div className="">
          {/* payments */}
          <div className="flex flex-col items-start gap-2 pt-2">
            <>
              <div className="grid w-full grid-cols-2 gap-4">
                <div className="mt-2 grid">
                  <CurrencyAmountInput
                    control={control}
                    currencies={currenciesSelector}
                    defaultCurrency={
                      defaultPaymentCurrency ?? business?.mainCurrency
                    }
                    label="Monto (*) "
                    name={`registeredPayments`}
                    placeholder="$0.00"
                    rules={{
                      required:
                        'Escoja el monto y la moneda que desea ingresar',
                      validate: {
                        amountGreaterThanZero: (value: CurrencyAmountValue) =>
                          value.amount > 0 || 'Monto debe ser mayor a 0',
                        validCurrency: (value: CurrencyAmountValue) =>
                          value.codeCurrency !== 'Moneda' ||
                          'Escoja una moneda',
                      },
                    }}
                  />
                </div>

                <div className="grid items-start py-2">
                  <Select
                    className=""
                    control={control}
                    data={paymentMethods}
                    defaultValue={defaultPaymentMethod ?? paymentMethods[0].id}
                    label="Método de pago"
                    name={`paymentWay`}
                    rules={{ required: '* Requerido' }}
                  />
                </div>

                {paymentWay === 'CASH' && (
                  <div className="col-span-full">
                    <InputPrefix
                      control={control}
                      label="Registro de caja"
                      name="operationNumber"
                      prefix={`RC-${moment().year()}/`}
                    />
                  </div>
                )}

                <div className="col-span-full">
                  <TextArea
                    control={control}
                    label="Observaciones"
                    name="observations"
                  />
                </div>
              </div>
            </>
          </div>
          <footer className="mt-5 flex w-full gap-x-3">
            <Button
              action={() => close()}
              color="white"
              full
              name="Cancelar"
              outline
              textColor="blue-800"
              //type="submit"
            />

            <Button
              action={onSubmitPay}
              color="slate-700"
              full
              name="Agregar"
              type="button"
            />
          </footer>
        </div>
      </form>
    </>
  )
}
